import React, { FC } from "react"
import styled from "@emotion/styled"
import { mobileFirstDevice } from "@/utils/media-queries"
import Box from "@/components/Box"

const GallerySection = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 125px;
  float: right;
  height: 400px;

  > :nth-child(1) {
    position: absolute !important;
    right: -10px;
    z-index: 1;
    width: 370px;
  }

  > :nth-child(2) {
    position: absolute !important;
    top: 170px;
    right: -10px;
    z-index: 2;
    width: 285px;
  }

  > :nth-child(3) {
    position: absolute !important;
    top: 27px;
    right: -10px;
    z-index: 3;
    width: 145px;
  }

  @media ${mobileFirstDevice.tablet} {
    margin-bottom: 75px;

    > :nth-child(1) {
      top: 15px;
      width: 380px;
      right: -52px;
    }

    > :nth-child(2) {
      top: 195px;
      right: -69px;
      width: 300px;
    }

    > :nth-child(3) {
      top: 45px;
      right: -69px;
      width: 154px;
    }
  }

  @media ${mobileFirstDevice.laptop} {
    margin-bottom: 75px;
    height: 664px;

    > :nth-child(1) {
      width: 680px;
      top: -24px;
      right: -140px;
    }

    > :nth-child(2) {
      top: 295px;
      right: -165px;
      width: 550px;
    }

    > :nth-child(3) {
      top: 24px;
      right: -165px;
      width: 294px;
    }
  }
`

const OfficeGallery: FC = () => {
  return (
    <GallerySection>
      <Box width={620}>
        <img
          alt={"Gallery 1"}
          src={`${process.env.ASSETS_BASE_URL}/careers-page/working-1.webp`}
          style={{ width: "100%", height: "100%" }}
          loading="lazy"
        />
      </Box>
      <Box width={573}>
        <img
          alt={"Gallery 2"}
          src={`${process.env.ASSETS_BASE_URL}/careers-page/working-2.webp`}
          style={{ width: "100%", height: "100%" }}
          loading="lazy"
        />
      </Box>
      <Box width={294}>
        <img
          alt={"Gallery 3"}
          src={`${process.env.ASSETS_BASE_URL}/careers-page/working-3.webp`}
          style={{ width: "100%", height: "100%" }}
          loading="lazy"
        />
      </Box>
    </GallerySection>
  )
}

export default OfficeGallery
